import moment from "moment";

// Filtros de SearchHeaderPO (unidad, sucursal y rango de fechas) reflejados en la URL:
// ?business=&location=&range=&dateStart=&dateEnd= (fechas solo con rango personalizado).
// El encabezado lee sus valores del store, así que applyUrlToHeader() debe llamarse en el
// created() de la pantalla, antes de que se cree <search-header-po>.

const RANGE_VALUES = ["1", "3", "4", "8", "9", "6", "7"];

export const queryInt = (value, fallback) => {
  const n = parseInt(value, 10);
  return Number.isInteger(n) && n >= 0 ? n : fallback;
};

export const queryList = (value) =>
  value ? String(value).split(",").filter((v) => v !== "") : [];

// Mismo cálculo de fechas que SearchHeaderPO.updateRange
const rangeDates = (range) => {
  const today = moment().format("YYYY-MM-DD");
  const daysBack = { "3": 7, "4": 30, "8": 60, "9": 90 }[range];
  if (range === "1") return { dateStart: today, dateEnd: today };
  if (daysBack) return { dateStart: moment().subtract(daysBack, "days").format("YYYY-MM-DD"), dateEnd: today };
  if (range === "6") {
    return {
      dateStart: moment().startOf("year").format("YYYY-MM-DD"),
      dateEnd: moment().endOf("year").format("YYYY-MM-DD"),
    };
  }
  return null;
};

const isDate = (value) => moment(value, "YYYY-MM-DD", true).isValid();

export default {
  methods: {
    // Pasa los valores de la URL al store. Solo acepta unidades y sucursales a las que el
    // usuario tiene acceso; lo demás se ignora y queda lo que había en el store.
    applyUrlToHeader() {
      const query = this.$route.query;
      const auth = this.$store.state.auth;

      const business = queryInt(query.business, null);
      if (business === 0 || (auth.bussines_units || []).some((b) => b.value == business)) {
        this.$store.commit("setBusiness", business);
      }

      const locationId = queryInt(query.location, null);
      if (locationId === 0) {
        this.$store.commit("setLocation", { text: "Todas", value: 0 });
      } else if (locationId !== null) {
        const location = (auth.locations || []).find((l) => l.value == locationId);
        if (location) {
          this.$store.commit("setLocation", { text: location.text, value: location.value });
        }
      }

      const range = RANGE_VALUES.includes(query.range) ? query.range : null;
      if (range) {
        const dates =
          range === "7" ? { dateStart: query.dateStart, dateEnd: query.dateEnd } : rangeDates(range);
        if (dates && isDate(dates.dateStart) && isDate(dates.dateEnd)) {
          this.$store.commit("setRangeSelected", range);
          this.$store.commit("setDateRange", dates);
          this.$store.commit("setInitialized", true);
        }
      }
    },

    // Parámetros de URL con el estado actual del encabezado
    headerUrlQuery() {
      const app = this.$store.state.app;
      const query = {};

      const business = app.filters.business;
      if (business !== null && business !== undefined && business !== "") query.business = String(business);
      const location = app.filters.location;
      const locationId = location !== null && typeof location === "object" ? location.value : location;
      if (locationId !== null && locationId !== undefined) query.location = String(locationId);
      if (app.rangeSelected) query.range = String(app.rangeSelected);
      if (app.rangeSelected == "7") {
        query.dateStart = app.date;
        query.dateEnd = app.date2;
      }
      return query;
    },

    // Reemplaza la URL (sin agregar entradas al historial) si cambió
    replaceUrlQuery(query) {
      const current = this.$route.query;
      const same =
        Object.keys(query).length === Object.keys(current).length &&
        Object.keys(query).every((k) => current[k] === query[k]);
      if (same) return;
      this.$router.replace({ query }).catch(() => {});
    },
  },
};
